import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "calendar-thin",
  "use": "calendar-thin-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"calendar-thin\">\n  <path fill-rule=\"evenodd\" d=\"M301,208h1v16h-1V208Zm16,0h1v16h-1V208Zm-16,0h17v1H301v-1Zm0,15h17v1H301v-1Zm6-14h-1m11,7v-1m-12-8h1v3h-1v-3Zm-1,6h3v1h-3v-1Zm4,0h3v1h-3v-1Zm4,0h3v1h-3v-1Zm-8,2h3v1h-3v-1Zm4,0h3v1h-3v-1Zm4,0h3v1h-3v-1Zm-8,2h3v1h-3v-1Zm4,0h3v1h-3v-1Zm4,0h3v1h-3v-1Zm-8,2h3v1h-3v-1Zm4,0h3v1h-3v-1Zm4,0h3v1h-3v-1Zm-3-12h1v3h-1v-3Zm4,0h1v3h-1v-3Z\" transform=\"translate(-301 -207)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/calendar-thin.svg
// module id = null
// module chunks = 